export const environment = {
  production: true,
  environmentName: 'LAB',
  azure: {
    clientId: '54a399f8-8781-43de-bd4f-eb4634da0566',
    tenantId: '4a24d27e-e46c-48c6-b3f8-4b1f0b04e1aa',
    redirectUri: 'https://inventorylab.wesportech.com.co',
    scopes: ['User.Read', 'GroupMember.Read.All'],
    apiScopes: ['api://54a399f8-8781-43de-bd4f-eb4634da0566/access_as_user']
  },
  securityGroups: {
    gestor: '6461dc2e-6ae0-41cb-bee1-b31ade3b15d5',
    admin: '6ff6f194-ceb7-4e99-97b2-a3aedf579ba8',
    lafUsers: '06de238d-f3df-4bbd-a01f-d5c340b6fbd9'
  },
  api: {
    // CQRS Pattern: Separate URLs for reads and writes
    writeUrl: 'https://fn-bff-inventory-lab.azurewebsites.net/api',  // fn-bff-inventory (commands)
    readUrl: 'https://fa-read-inventory-lab.azurewebsites.net/api',  // fa-read-inventory (queries)
    baseUrl: 'https://fn-bff-inventory-lab.azurewebsites.net/api',   // Default for compatibility
    timeout: 30000
  }
};
